/** moderator/evaluations — HOOKS. Evaluations are immutable once produced. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { evaluationsApi } from './api';
import { evaluationsKeys } from './keys';
import type { EvalKey, EvaluationResult } from './types';

export function useEvaluation(k: EvalKey | null) {
  return useQuery<EvaluationResult>({
    queryKey: k ? evaluationsKeys.detail(k.gameName, k.worldName, k.cohortId, k.matchFolder) : [...evaluationsKeys.all(), 'none'],
    queryFn: () => evaluationsApi.get(k!.gameName, k!.worldName, k!.cohortId, k!.matchFolder),
    enabled: !!k,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useRunEvaluation() {
  const qc = useQueryClient();
  return useMutation<EvaluationResult, Error, EvalKey>({
    mutationFn: (k) => evaluationsApi.run(k.gameName, k.worldName, k.cohortId, k.matchFolder),
    onSuccess: (data, k) => {
      qc.setQueryData(evaluationsKeys.detail(k.gameName, k.worldName, k.cohortId, k.matchFolder), data);
    },
  });
}
